const getProductTypeDeliveries = (productTypes, productTypeDeliveryConfig) => {
  if (!productTypeDeliveryConfig) return void 0;
  if (productTypes.size > 1) {
    const hasMixed = productTypeDeliveryConfig.find((cfg) => cfg.type === "MIXED");
    if (hasMixed) {
      return [hasMixed.expectedDeliveryDays];
    }
  }
  for (const productTypeDelivery of productTypeDeliveryConfig) {
    if (productTypes.has(productTypeDelivery.type)) {
      return [productTypeDelivery.expectedDeliveryDays];
    }
  }
};
export {
  getProductTypeDeliveries
};
//# sourceMappingURL=get-product-types-deliveries.js.map
